module.exports = __webpack_public_path__ + "static/media/NenadLecic.6246292d.jpg";